const SlalomDistances = {
    SLALOM_DISTANCE_4_6M: 'SLALOM_DISTANCE_4_6M',
    SLALOM_DISTANCE_LESS_THAN_9M: 'SLALOM_DISTANCE_LESS_THAN_9M',
    SLALOM_DISTANCE_9_11M: 'SLALOM_DISTANCE_9_11M',
    SLALOM_DISTANCE_GREATER_11M: 'SLALOM_DISTANCE_GREATER_11M',
    GIANT_SLALOM_DISTANCE_LESS_24M: 'GIANT_SLALOM_DISTANCE_LESS_24M',
    GIANT_SLALOM_DISTANCE_24_26M: 'GIANT_SLALOM_DISTANCE_24_26M',
    GIANT_SLALOM_DISTANCE_GREATER_26M: 'GIANT_SLALOM_DISTANCE_GREATER_26M'
}

const SlalomDistanceDbString = {
    SLALOM_DISTANCE_4_6M: '4 - 6',
    SLALOM_DISTANCE_LESS_THAN_9M: '< 9',
    SLALOM_DISTANCE_9_11M: '9 - 11',
    SLALOM_DISTANCE_GREATER_11M: '> 11',
    GIANT_SLALOM_DISTANCE_LESS_24M: '< 24',
    GIANT_SLALOM_DISTANCE_24_26M: '24 - 26',
    GIANT_SLALOM_DISTANCE_GREATER_26M: '> 26'
}

const SlalomDbToEnumString = {
    '4 - 6': "SLALOM_DISTANCE_4_6M",
    '< 9': "SLALOM_DISTANCE_LESS_THAN_9M",
    '9 - 11': "SLALOM_DISTANCE_9_11M",
    '> 11': "SLALOM_DISTANCE_GREATER_11M",
    '< 24': "GIANT_SLALOM_DISTANCE_LESS_24M",
    '24 - 26': "GIANT_SLALOM_DISTANCE_24_26M",
    '> 26': "GIANT_SLALOM_DISTANCE_GREATER_26M"
}

export default SlalomDistances;
export {SlalomDistanceDbString, SlalomDbToEnumString}
